import { GlobalStore } from "@roc/feature-app-core";
import { action, flow, makeObservable, observable } from "mobx";
import { CompToolPhotosService } from "../services/compToolPhotosService";
import { isNil } from "@roc/feature-utils";

export class CompToolPhotosStore {
  globalStore: GlobalStore;
  compToolPhotosService: CompToolPhotosService;
  allPhotosImages: any[]
  allPhotosImagesPerDate: any[]
  selectedPhoto: any;
  openIndividualPhoto: boolean

  constructor(globalStore) {
    this.globalStore = globalStore;
    this.compToolPhotosService = new CompToolPhotosService();
    this.allPhotosImages = [];
    this.allPhotosImagesPerDate = [];
    this.openIndividualPhoto = false;

    makeObservable(this, {
      getCompAllPhotos: flow,
      getCompAllPhotosImagesPerDate: flow,
      allPhotosImages: observable,
      allPhotosImagesPerDate: observable,
      setAllPhotosImages: action,
      setAllPhotosImagesPerDate: action,
      selectedPhoto: observable,
      setSelectedPhoto: action,
      openIndividualPhoto: observable,
      setOpenIndividualPhoto: action
    });
  }

  reset() {
    this.allPhotosImagesPerDate = [];
    this.allPhotosImages = [];
    this.selectedPhoto = [];
    this.openIndividualPhoto = false;
  }

  setOpenIndividualPhoto(openIndividualPhoto: boolean) {
    this.openIndividualPhoto = openIndividualPhoto;
  }

  setSelectedPhoto(selectedPhoto: any) {
    this.selectedPhoto = selectedPhoto;
  }

  setAllPhotosImages(images) {
    this.allPhotosImages = images;
  }

  setAllPhotosImagesPerDate(imagesPerDate) {
    this.allPhotosImagesPerDate = imagesPerDate
  }

  *getCompAllPhotos(property) {
    try {
      if (!isNil(property.data.mls_id)) {
        const response = yield this.compToolPhotosService.getCompAllPhotos(property.data.mls_id);
        if (response == null) {
          this.globalStore.notificationStore.showErrorNotification({
            message: 'Error while getting all photos',
          });
          this.setAllPhotosImages([]);
        } else {
          const compImages = response.data && JSON.parse(response.data?.data);
          this.setAllPhotosImages(compImages?.images);
        }
      } else {
        this.setAllPhotosImages([]);
      }
    } catch (e) {
      console.log(e);
      this.setAllPhotosImages([]);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while getting all photos',
      });
      return [];
    }

  }

  *getCompAllPhotosImagesPerDate(property) {
    try {
      if (!isNil(property.property_id)) {
        const id = property.property_id.split('_')[0];
        const response = yield this.compToolPhotosService.getCompAllPhotosImagesPerDate(id);

        if (response == null) {
          this.globalStore.notificationStore.showErrorNotification({
            message: 'Error while getting all photos images per date',
          });
          this.setAllPhotosImagesPerDate([]);
        } else {
          const compImages = response.data && JSON.parse(response.data?.data);
          this.setAllPhotosImagesPerDate(compImages?.listings);
        }
      } else {
        this.setAllPhotosImagesPerDate([]);
      }
    } catch (e) {
      console.log(e);
      this.setAllPhotosImagesPerDate([]);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while getting all photos images per date',
      });
      return [];
    }
  }
}
